// extracted by mini-css-extract-plugin
export var addButton = "_d0-4";
export var contentBlockImage = "_d0-i";
export var contentBlockWidgetPreview = "_d0-g";
export var fulfillmentCutoffWidgetPreview = "_d0-9";
export var imageBackdrop = "_d0-6";
export var imageIcon = "_d0-8";
export var lowProfileImageContainer = "_d0-b";
export var lowProfileImageIcon = "_d0-f";
export var lowProfileImageIconContainer = "_d0-e";
export var lowProfileImagePlaceholder = "_d0-d";
export var lowProfileProductImage = "_d0-c";
export var lowProfileProductUpsellWidgetPreview = "_d0-a";
export var productCard = "_d0-5";
export var productImage = "_d0-7";
export var productReviewsWidgetPreview = "_d0-h";
export var progressBar = "_d0-1";
export var progressBarFill = "_d0-2";
export var progressBarTrack = "_d0-3";
export var shippingOptionWidgetPreview = "_d0-j";
export var shippingUpsellProgressBar = "_d0-k";
export var thresholdUpsellWidgetPreview = "_d0-0";